(function () {
  var ANGLE_X = 10636103680309;
  var DUSTLOCK = 10595175727413;
  var CODE = "AXDLSHIP";
  var busy = false;

  function combo(cart) {
    var hasAX = false, hasDL = false;
    (cart.items || []).forEach(function (item) {
      if (item.product_id === ANGLE_X) hasAX = true;
      if (item.product_id === DUSTLOCK) hasDL = true;
    });
    return hasAX && hasDL;
  }

  function codeOn(cart) {
    return (cart.discount_codes || []).some(function (d) {
      return String(d.code || "").toUpperCase() === CODE;
    });
  }

  function sync() {
    if (busy) return;
    busy = true;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = combo(cart);
        var on = codeOn(cart);
        if (want === on) return null;
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ discount: want ? CODE : "" })
        });
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  document.addEventListener("DOMContentLoaded", sync);
  window.addEventListener("pageshow", sync);
  document.addEventListener("click", function () { setTimeout(sync, 500); }, true);
  setInterval(sync, 2000);
})();
